const SERVER_NAME_KEY = 'apm_server';
const BIZ_CHANNEL_KEY = 'apm_biz_channel';
const ENV_KEY = 'apm_env';
const SOURCE_KEY = 'apm_source';

const app = {
  namespaced: true,
  state: {
    flowList: [], // 流量列表
    envList: [], // 环境列表
    sourceList: [], // 来源列表
    serverName: sessionStorage.getItem(SERVER_NAME_KEY) || '', // 当前选中的服务名称
    env: sessionStorage.getItem(ENV_KEY) ?? '', // 当前选中的环境
    source: sessionStorage.getItem(SOURCE_KEY) ?? '', // 当前选中的来源
    analyzeTime: '',
    needUpdateSource: false, // 是否需要更新来源
    serverList: [], // 服务列表
    topologyTypeList: [], // 拓扑类型列表
    bizChannelList: [], // 平台列表
    bizChannel: sessionStorage.getItem(BIZ_CHANNEL_KEY), // 平台
  },
  getters: {
    flowList: (state) => state.flowList, // 流量列表
    sourceList: (state) => state.sourceList, // 来源列表
    envList: (state) => state.envList, // 环境列表
    env: (state) => state.env, // 当前选中的环境
    source: (state) => state.source, // 当前选中的来源
    analyzeTime: (state) => state.analyzeTime,
    serverList: (state) => state.serverList, // 服务列表
    serverName: (state) => state.serverName, // 服务名称
    topologyTypeList: (state) => state.topologyTypeList, // 拓扑类型列表
    bizChannelList: (state) => state.bizChannelList, // 平台列表
    bizChannel: (state) => state.bizChannel, // 平台名称
  },
  actions: {
    /**
     * 设置平台列表
     */
    setBizChannelList({ commit }, bizChannel) {
      sessionStorage.setItem('apm_biz_channel_list', JSON.stringify(bizChannel));
      commit('SET_BIZ_CHANNEL_LIST', bizChannel);
    },

    /**
     * 设置平台
     */
    setBizChannel({ commit }, bizChannel) {
      sessionStorage.setItem(BIZ_CHANNEL_KEY, bizChannel);
      commit('SET_BIZ_CHANNEL', bizChannel);
    },

    /**
     * 设置来源列表
     */
    setSourceList({ commit }, source) {
      sessionStorage.setItem('apm_source_list', JSON.stringify(source));
      commit('SET_SOURCE_LIST', source);
    },

    /**
     * 设置流量列表
     */
    setFlowList({ commit }, flow) {
      sessionStorage.setItem('apm_flow_list', JSON.stringify(flow));
      commit('SET_FLOW_LIST', flow);
    },

    /**
     * 设置环境列表
     */
    setEnvList({ commit }, env) {
      sessionStorage.setItem('apm_env_list', JSON.stringify(env));
      commit('SET_ENV_LIST', env);
    },

    /**
     * 设置当前选中的环境
     */
    setEnv({ commit }, env) {
      sessionStorage.setItem(ENV_KEY, env);
      commit('SET_ENV', env);
    },

    /**
     * 设置当前选中的来源
     */
    setSource({ commit }, source) {
      sessionStorage.setItem(SOURCE_KEY, source);
      commit('SET_SOURCE', source);
    },

    /**
     * 设置当前的服务列表
     */
    setServerList({ commit }, list = []) {
      commit('SET_SERVER_LIST', list);
    },

    /**
     * 设置当前的选中的服务
     */
    setServerName({ commit }, name) {
      commit('SET_SERVER_NAME', name);
    },

    /**
     * 设置区间时间
     */
    setAnalyzeTime({ commit }, time) {
      commit('SET_ANALYZE_TIME', time);
    },

    /**
     * 设置当前拓扑类型列表
     */
    setTopologyTypeList({ commit }, list) {
      commit('SET_TOPOLOGY_TYPE_LIST', [{ code: '', name: '全部' }, ...list]);
    },
  },
  mutations: {
    SET_NEED_UPDATE_SOURCE: (state, payload) => {
      state.needUpdateSource = payload;
    },
    SET_SERVER_NAME: (state, name) => {
      sessionStorage.setItem(SERVER_NAME_KEY, name);
      state.serverName = name;
    },
    SET_FLOW_LIST: (state, list) => {
      state.flowList = list;
    },
    SET_SOURCE_LIST: (state, list) => {
      state.sourceList = list;
    },
    SET_ENV_LIST: (state, list) => {
      state.envList = list;
    },
    SET_ENV: (state, env) => {
      state.env = env;
      state.needUpdateSource = true;
    },
    SET_SOURCE: (state, source) => {
      state.source = source;
    },
    SET_ANALYZE_TIME: (state, time) => {
      state.analyzeTime = time;
    },
    SET_SERVER_LIST: (state, list) => {
      state.serverList = list;
    },
    SET_TOPOLOGY_TYPE_LIST: (state, list) => {
      state.topologyTypeList = list;
    },
    SET_BIZ_CHANNEL_LIST: (state, list) => {
      state.bizChannelList = list;
    },
    SET_BIZ_CHANNEL: (state, bizChannel) => {
      state.bizChannel = bizChannel;
    },
  },
};

export default app;
